export const checkoutUrl =
  'https://pastry-instructor-ready.impultienda.ar/checkout'

export function trackCheckout() {
  const fbq = (
    window as Window & {
      fbq?: (...args: unknown[]) => void
    }
  ).fbq
  fbq?.('track', 'InitiateCheckout', {
    content_name: 'Pastry Instructor Ready',
    value: 27,
    currency: 'USD',
  })
}
